export default "__VITE_ASSET__CcDq_p9$__"